import React from 'react';
import { getReadableFullDate } from 'src/utils/helpers';
import { INotification, NOTIFICATION_TYPES } from 'src/api/base/other';

// Icons
import { QuestionIco } from '../../../../../UserLayout/icons/QuestionIco';
import { EmailDocIco } from '../../../../../UserLayout/icons/EmailDocIco';
import { useHistory } from 'react-router';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { USER_ROLES } from 'src/utils/types/user';
import { NotificationItemContainer } from '../components/NotificationItemContainer';

type PNotificationItem = {
  notification: INotification;
};

const NOTIFICATION_ICONS = {
  [NOTIFICATION_TYPES.Interview]: EmailDocIco,
  [NOTIFICATION_TYPES.Question]: QuestionIco,
};

export const NotificationItem: React.FC<PNotificationItem> = (props) => {
  const { notification } = props;
  const Ico = NOTIFICATION_ICONS[notification.type];
  const history = useHistory();
  const user = useSelector((state: RootState) => state.auth.user);

  const fullNotificationData = `${notification.data} on ${getReadableFullDate(
    notification.created_at,
  )}`;

  function createMarkup() {
    return { __html: fullNotificationData };
  }

  const handleClick = () => {
    const type =
      notification.type === NOTIFICATION_TYPES.Interview
        ? NOTIFICATION_TYPES.Interview
        : NOTIFICATION_TYPES.Question;

    let destination = '/';
    if (user?.role === USER_ROLES.EXPERT) {
      if (type === NOTIFICATION_TYPES.Interview) {
        destination = APP_ROUTES.EXPERT_PENDING_INTERVIEWS;
      } else {
        destination = APP_ROUTES.EXPERT_QUESTIONS;
      }
    }
    if (user?.role === USER_ROLES.JOURNALIST) {
      if (type === NOTIFICATION_TYPES.Question) {
        destination = APP_ROUTES.JOURNALIST_QUESTIONS;
      } else {
        destination = APP_ROUTES.JOURNALIST_ALL_INTERVIEWS;
      }
    }

    history.push(destination);
  };

  return (
    <NotificationItemContainer
      NotificationIcon={Ico}
      isHighlighted={Boolean(notification.read_at)}
      onClick={handleClick}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={createMarkup()} />
    </NotificationItemContainer>
  );
};
